<template>
  <div :id="item.id" v-if="item.display" class="collect-form-item" :key="item.id">
    <div class="collect-form-item-title">
      <!-- 序号 -->
      {{ getSerialNumber( serialNumberType, item.index + 1, "", ". ") }}
      <!-- 标题 -->
      <span>{{ item.title }}</span> &nbsp;
      <!-- 必填 -->
      <span v-if="item.required" class="collect-form-item-required-mark">*</span>
    </div>
    <div class="collect-form-item-description" v-if="item.description">{{ item.description }}</div>
    <div class="collect-form-item-body">
      <!-- 填写题 - start -->
      <van-field
        v-if="item.type === 'input'"
        v-model="item.value"
        :name="item.id"
        :type="item.format ? item.format : 'text'"
        class="collect-form-item-input"
        :rules="[{ validator, message: getValidateMsg, item }]"
        maxlength="1000"
        :disabled="readonly"
      ></van-field>
      <!-- 填写题 - end -->

      <!-- 简述题 - start -->
      <van-field
        v-if="item.type === 'textarea'"
        v-model="item.value"
        :name="item.id"
        type="textarea"
        class="collect-form-item-input"
        rows="3"
        autosize
        :rules="[{ validator, message: getValidateMsg, item }]"
        maxlength="1000"
        :disabled="readonly"
      ></van-field>
      <!-- 简述题 - end -->

      <!-- 下拉选项 - start -->
      <van-field
        v-if="item.type === 'select'"
        v-model="item.value"
        :name="item.id"
        :rules="[
          { validator, message: getValidateMsg, trigger: 'onChange', item },
        ]"
      >
        <template #input>
          <div class="collect-form-item-select-wrapper">
            <select class="collect-form-item-select" v-model="item.value" :disabled="readonly">
              <option v-for="(option, index) in item.options" :key="index" :value="option.value">{{ option.label }}</option>
            </select>
            <van-icon name="arrow-down" class="collect-form-item-select-arrow" />
          </div>
        </template>
      </van-field>
      <!-- 下拉选项 - end -->

      <!-- 单选题 - start -->
      <van-field
        v-if="item.type === 'radio'"
        :name="item.id"
        :rules="[
          { validator, message: getValidateMsg, trigger: 'onChange', item },
        ]"
      >
        <template #input>
          <RadioRenderer :item="item" :readonly="readonly"></RadioRenderer>
        </template>
      </van-field>
      <!-- 单选题 - end -->

      <!-- 多选题 - start -->
      <van-field
        v-if="item.type === 'checkbox'"
        :name="item.id"
        :rules="[
          { validator, message: getValidateMsg, trigger: 'onChange', item },
        ]"
      >
        <template #input>
          <CheckboxRenderer :item="item" :readonly="readonly"></CheckboxRenderer>
        </template>
      </van-field>
      <!-- 多选题 - end -->

      <!-- 评分题 start -->
      <van-field v-if="item.type === 'rate'" :name="item.id" :rules="[{ validator, message: getValidateMsg, item }]">
        <template #input>
          <RateRenderer :item="item" :readonly="readonly"></RateRenderer>
        </template>
      </van-field>
      <!-- 评分题 end -->

      <!-- 日期/时间/月份 - start -->
      <van-field
        v-if="
          item.type === 'date' || item.type === 'time' || item.type === 'month'
        "
        v-model="item.value"
        :name="item.id"
        :type="item.type"
        class="collect-form-item-input"
        :rules="[{ validator, message: getValidateMsg, item }]"
        maxlength="1000"
        :disabled="readonly"
      ></van-field>
      <!-- 日期/时间/月份 - end -->

      <!-- 矩阵单选 - start -->
      <van-field
        v-if="item.type === 'matrix-radio'"
        :name="item.id"
        :rules="[
          { validator, message: getValidateMsg, trigger: 'onChange', item },
        ]"
        class="collect-form-matrix-field"
      >
        <template #input>
          <div v-for="(row, rowIdx) in item.rows" :key="rowIdx" class="collect-form-matrix-row">
            <div class="collect-form-matrix-row-title">{{ row.title }}</div>
            <div class="collect-form-matrix-row-content">
              <RadioRenderer :item="item" :readonly="readonly" :row="row"></RadioRenderer>
            </div>
          </div>
        </template>
      </van-field>
      <!-- 矩阵单选 - end -->

      <!-- 矩阵多选 - start -->
      <van-field
        v-if="item.type === 'matrix-checkbox'"
        :name="item.id"
        :rules="[
          { validator, message: getValidateMsg, trigger: 'onChange', item },
        ]"
        class="collect-form-matrix-field"
      >
        <template #input>
          <div v-for="(row, rowIdx) in item.rows" :key="rowIdx" class="collect-form-matrix-row">
            <div class="collect-form-matrix-row-title">{{ row.title }}</div>
            <div class="collect-form-matrix-row-content">
              <CheckboxRenderer :item="item" :readonly="readonly" :row="row"></CheckboxRenderer>
            </div>
          </div>
        </template>
      </van-field>
      <!-- 矩阵多选 - end -->

      <!-- 矩阵评分 start -->
      <van-field
        v-if="item.type === 'matrix-rate'"
        :name="item.id"
        :rules="[
          { validator, message: getValidateMsg, trigger: 'onChange', item },
        ]"
        class="collect-form-matrix-field"
      >
        <template #input>
          <div v-for="(row, rowIdx) in item.rows" :key="rowIdx" class="collect-form-matrix-row">
            <div class="collect-form-matrix-row-title">{{ row.title }}</div>
            <div class="collect-form-matrix-row-content">
              <RateRenderer :item="item" :readonly="readonly" :row="row"></RateRenderer>
            </div>
          </div>
        </template>
      </van-field>
      <!-- 矩阵评分 end -->

      <!-- 图片上传 start -->
      <van-field v-if="item.type === 'img-upload'" :name="item.id" :rules="[{ validator, message: getValidateMsg, item }]">
        <template #input>
          <ImageUploaderRenderer :formId="formId" :item="item" :readonly="readonly"></ImageUploaderRenderer>
        </template>
      </van-field>
      <!-- 图片上传 end -->

      <!-- 文件上传 start -->
      <van-field v-if="item.type === 'file-upload'" :name="item.id" :rules="[{ validator, message: getValidateMsg, item }]">
        <template #input>
          <FileUploaderRenderer :formId="formId" :item="item" :readonly="readonly"></FileUploaderRenderer>
        </template>
      </van-field>
      <!-- 文件上传 end -->
    </div>
  </div>
</template>

<script>
import { isMobileNumber } from "@/utils/RegExp.js";
import RadioRenderer from "./ComponentsRenderer/RadioRenderer.vue";
import CheckboxRenderer from "./ComponentsRenderer/CheckboxRenderer.vue";
import RateRenderer from "./ComponentsRenderer/RateRenderer.vue";
import ImageUploaderRenderer from "./ComponentsRenderer/ImageUploaderRenderer.vue";
import FileUploaderRenderer from "./ComponentsRenderer/FileUploaderRenderer.vue";

export default {
  components: {
    RadioRenderer,
    CheckboxRenderer,
    RateRenderer,
    ImageUploaderRenderer,
    FileUploaderRenderer,
  },
  props: ["formId", "item", "serialNumberType", "readonly"],
  data() {
    return {};
  },
  watch: {
    "item.rows": {
      deep: true, //深度监听
      handler: function () {
        if (
          this.item.type === "matrix-radio" ||
          this.item.type === "matrix-checkbox" ||
          this.item.type === "matrix-rate"
        ) {
          console.log(this.item.id, this.item.type, "item.rows changed");
          this.item.value = JSON.stringify(this.item.rows);
        }
      },
    },
  },
  created() {},
  methods: {
    // 表单项验证
    validator(val, rule) {
      // return false 则代表校验没通过
      // item.errMsg 为错误提示信息

      let item = rule.item; // 表单项
      let value = item.value; // 表单项输入值

      // 必填校验
      if (item.required) {
        if (value == undefined || value == null || value == "" || value == []) {
          item.errMsg = "此项为必填项";
          return false;
        }
      }

      // 多选框最少选择校验
      if (item.type === "checkbox" && item.min && item.min > 0) {
        if (val && item.min && item.min > 0 && val.length < item.min) {
          item.errMsg = `请选择至少 ${item.min} 项`;
          return false;
        }
      }

      // 多选框最多选择校验
      if (item.type === "checkbox" && item.max && item.max > 0) {
        if (val && item.max && item.max > 0 && val.length > item.max) {
          item.errMsg = `请选择最多 ${item.max} 项`;
          return false;
        }
      }

      // 单选框、多选框的“其他”项校验
      if (
        (item.type === "radio" || item.type === "checkbox") &&
        item.hasOtherOption
      ) {
        let otherOptionCheck = false;
        if (item.type === "radio" && item.value === "other") {
          otherOptionCheck = true;
        }
        if (item.type === "checkbox" && item.value.indexOf("other") >= 0) {
          otherOptionCheck = true;
        }
        // 已勾选“其他”项，并且值为空
        if (otherOptionCheck && !item.otherText) {
          item.errMsg = "请填写“其他”项内容";
          return false;
        }
      }

      // 单行文本、多行文本最少输入字数校验
      if (
        (item.type === "input" || item.type === "textarea") &&
        item.min &&
        item.min > 0 &&
        !item.format // 未限制输入格式时
      ) {
        if (val && item.min && item.min > 0 && val.length < item.min) {
          item.errMsg = `请输入至少${item.min}个字`;
          return false;
        }
      }

      // 单行文本输入格式限制校验
      if (item.type === "input" && item.format) {
        if (
          item.format === "tel" &&
          item.value &&
          !isMobileNumber(item.value)
        ) {
          item.errMsg = "请输入正确的手机号码";
          return false;
        }
        if (
          item.format === "number" &&
          item.value &&
          !/^-?\d+$/.test(item.value)
        ) {
          item.errMsg = "请输入数字";
          return false;
        }
        if (
          item.format === "email" &&
          item.value &&
          !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(item.value)
        ) {
          item.errMsg = "请输入正确的电子邮箱";
          return false;
        }
        if (
          item.format === "idcard" &&
          item.value &&
          !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(item.value)
        ) {
          item.errMsg = "请输入正确的身份证号";
          return false;
        }
      }

      // 矩阵单选、矩阵多选、矩阵评分必填校验
      if (
        item.required &&
        (item.type === "matrix-radio" ||
          item.type === "matrix-checkbox" ||
          item.type === "matrix-rate")
      ) {
        let emptyRowTitle = [];
        for (let i = 0; i < item.rows.length; i++) {
          let row = item.rows[i];
          let value = row.value;
          if (
            value == undefined ||
            value == null ||
            value == "" ||
            value == []
          ) {
            emptyRowTitle.push("“" + row.title + "”");
          }
        }
        if (emptyRowTitle.length > 0) {
          item.errMsg = emptyRowTitle.join("、") + "还未选择";
          return false;
        }
      }

      // 矩阵多选题 最少选择、最多选择校验
      if (item.type === "matrix-checkbox") {
        let minErrRowTitle = []; // 不满足最少选择 行标题
        let maxErrRowTitle = []; // 不满足最多选择 行标题

        for (let i = 0; i < item.rows.length; i++) {
          let row = item.rows[i];
          let value = row.value;

          // 最少选择校验
          if (item.min && item.min > 0 && value && value.length < item.min) {
            minErrRowTitle.push("“" + row.title + "”");
          }
          // 最多选择校验
          if (item.max && item.max > 0 && value && value.length > item.max) {
            maxErrRowTitle.push("“" + row.title + "”");
          }
        }
        let errMsgArr = [];
        if (minErrRowTitle.length > 0) {
          errMsgArr.push(
            minErrRowTitle.join("、") + `请选择至少 ${item.min} 项`
          );
        }
        if (maxErrRowTitle.length > 0) {
          errMsgArr.push(
            maxErrRowTitle.join("、") + `请选择最多 ${item.max} 项`
          );
        }

        if (errMsgArr.length > 0) {
          item.errMsg = errMsgArr.join("，");
          return false;
        }
      }

      delete item.errMsg;
      return true;
    },
    // 获取校验失败提示文字
    getValidateMsg: function (val, rule) {
      return rule.item.errMsg;
    },
  },
};
</script>
<style scoped>
@import url(./CollectForm.css);
</style>